import React from "react"

import ContentfulTextBlurb from "components/page-components/text"

const TextBlurb = ({ elRef, element }) => (
  <span ref={elRef}>
    <ContentfulTextBlurb component={element} isPromotionalPlacement />
  </span>
)

export default TextBlurb
